module.exports = __webpack_public_path__ + "img/googleMap.6b695790.jpg";